import React, { useState } from 'react';
import './ContactSection.css';
import { submitContactForm } from '../../mock';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    organization: '',
    message: ''
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: '', message: '' });

    try {
      const result = await submitContactForm(formData);
      setStatus({ 
        type: 'success', 
        message: 'Thank you for reaching out. We will respond within 48 hours.' 
      });
      setFormData({ name: '', email: '', organization: '', message: '' });
    } catch (error) {
      setStatus({ 
        type: 'error', 
        message: 'Unable to send message. Please email us directly at contact@tara-ventures.com' 
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="contact-section section-padding">
      <div className="container">
        <div className="contact-header observe-fade">
          <div className="section-label">Get In Touch</div>
          <h2 className="heading-1">Start a Conversation</h2>
          <p className="contact-intro body-regular">
            For partnership inquiries, investment discussions, or technical collaboration.
          </p>
        </div>

        <div className="contact-content">
          <div className="contact-info observe-fade">
            <div className="info-item">
              <h3 className="heading-3">Email</h3>
              <a href="mailto:contact@tara-ventures.com" className="contact-link body-large">
                contact@tara-ventures.com
              </a>
            </div>

            <div className="info-item">
              <h3 className="heading-3">Response Time</h3>
              <p className="body-regular info-text">
                We typically respond to inquiries within 48 hours during business days.
              </p>
            </div>
          </div>

          <div className="contact-form-wrapper observe-fade">
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name" className="form-label">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="form-input"
                  placeholder="Your name"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email" className="form-label">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="form-input"
                  placeholder="your@email.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="organization" className="form-label">Organization (Optional)</label>
                <input
                  type="text"
                  id="organization"
                  name="organization"
                  value={formData.organization}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="Your organization or company"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message" className="form-label">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="6"
                  className="form-textarea"
                  placeholder="Describe your inquiry or proposal..."
                ></textarea>
              </div>

              {status.message && (
                <div className={`form-status ${status.type}`}>
                  {status.message}
                </div>
              )}

              <button 
                type="submit" 
                className="btn-primary"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Footer with gold mandala line */}
      <footer className="footer">
        <div className="container">
          <div className="footer-divider">
            <svg width="100%" height="60" viewBox="0 0 800 60" xmlns="http://www.w3.org/2000/svg">
              <line x1="0" y1="30" x2="350" y2="30" stroke="#d4af37" strokeWidth="1" opacity="0.3" />
              
              <g transform="translate(400, 30)">
                <circle cx="0" cy="0" r="12" fill="none" stroke="#d4af37" strokeWidth="1" opacity="0.5" />
                <circle cx="0" cy="0" r="6" fill="none" stroke="#d4af37" strokeWidth="1" opacity="0.7" />
                <circle cx="0" cy="0" r="2" fill="#d4af37" opacity="0.8" />
              </g>
              
              <line x1="450" y1="30" x2="800" y2="30" stroke="#d4af37" strokeWidth="1" opacity="0.3" />
            </svg>
          </div>

          <div className="footer-content">
            <p className="body-small footer-text">
              © 2025 Tara Ventures. Research. Design. Build.
            </p>
          </div>
        </div>
      </footer>
    </section>
  );
};

export default ContactSection;